import { useState } from "react";
import { api } from "../../lib/api";
import { RecoveryInfoSheet } from "./RecoveryInfoSheet";
import "./recovery-bar.css";

// v30 — Režim prežitia je stav CELEJ appky, nie vlastnosť tabu Dnes: keď beží, človek ho má
// vidieť aj v Organizéri, v Social aj v Účte. Preto tmavý pruh úplne navrchu, nad hlavičkou —
// rovnaká rola, akú má v systéme stavový riadok: hovorí, v akom režime sa nachádzaš, a dá sa
// z neho vystúpiť. Nič iné nerobí a nedá sa zavrieť (režim by tým ostal skrytý).

const dayOf = (from, until, today) => {
  if (!from || !until) return null;
  const ms = 864e5;
  const t0 = Date.parse(from + "T00:00:00");
  const t1 = Date.parse(until + "T00:00:00");
  const td = Date.parse(today + "T00:00:00");
  if (![t0, t1, td].every(Number.isFinite) || t1 < t0) return null;
  const n = Math.round((td - t0) / ms) + 1;
  const total = Math.round((t1 - t0) / ms) + 1;
  return n >= 1 && n <= total ? { n, total } : null;
};

export function RecoveryBar({ from, until, today, onStopped }) {
  const [info, setInfo] = useState(false);
  const d = dayOf(from, until, today);
  const stop = async (e) => {
    e.stopPropagation();   // „Ukončiť" nesmie zároveň otvoriť okno pod prstom
    try {
      await api("/api/recovery/stop", { method: "POST", body: {} });
      onStopped && onStopped();
    } catch { /* offline — lišta ostáva, režim beží ďalej */ }
  };
  return (
    <>
      <div className="bz-recbar" role="status">
        {/* celá lišta je tlačidlo do vysvetľujúceho okna — je to jediné miesto, kde sa
            dá zistiť, čo režim s dňom robí a ktoré návyky uspal */}
        <div className="bz-recbar__inner" role="button" tabIndex={0}
          aria-label="Režim prežitia — čo to znamená"
          onClick={() => setInfo(true)}
          onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setInfo(true); } }}>
          <span className="bz-recbar__label">
            Režim prežitia{d && <> · deň {d.n} z {d.total}</>}
          </span>
          <button type="button" className="bz-recbar__stop" onClick={stop}>Ukončiť</button>
        </div>
      </div>
      {info && (
        <RecoveryInfoSheet onClose={() => setInfo(false)} onChanged={onStopped} />
      )}
    </>
  );
}
